import PropTypes from 'prop-types'
import React from 'react'
import EmailCitizenField from '../question_fields/EmailCitizenField'

const Citizen = props => {
  const { index, name, question, disabled = false, margin } = props
  return <EmailCitizenField index={index} {...question} name={name} disabled={disabled} margin={margin} />
}

const EmailQuestion = {
  Citizen,
  name: 'EmailQuestion'
}

export default EmailQuestion

Citizen.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  question: PropTypes.object
}
